import { objectToGetParams as n } from "./helpers.js";
const i = {
  email: (t) => {
    const { url: e, text: r = "", longtext: o = "" } = t;
    return `mailto:${n({
      subject: r,
      body: `${o} 

» ${e}`
    })}`;
  },
  facebook: (t) => {
    const { url: e, text: r = "", longtext: o = "", hashtag: s = "" } = t;
    return `https://www.facebook.com/sharer/sharer.php${n({
      u: e,
      quote: r || o ? `${r} 
${o}` : "",
      hashtag: s
    })}`;
  },
  twitter: (t) => {
    const { url: e, text: r = "", via: o = "", hashtags: s = [] } = t;
    return `https://twitter.com/share${n({
      url: e,
      text: r,
      via: o,
      hashtags: s.join(",")
    })}`;
  },
  googleplus: (t) => {
    const { url: e } = t;
    return `https://plus.google.com/share${n({
      url: e
    })}`;
  },
  linkedin: (t) => {
    const { url: e, text: r = "", longtext: o = "" } = t;
    return `https://linkedin.com/shareArticle${n({
      url: e,
      title: r,
      summary: o
    })}`;
  },
  pinterest: (t) => {
    const { media: e, text: r = "" } = t;
    return `https://pinterest.com/pin/create/button/${n({
      media: e,
      description: r
    })}`;
  }
};
function u(t) {
  return !!i.hasOwnProperty(t);
}
function c(t) {
  const { network: e, ...r } = t, { url: o, media: s } = r, a = e.toLowerCase();
  if (!a) throw new Error("the ShareButton's 'network' prop can't be undefined");
  if (!u(a)) throw new Error("the 'network' prop's value is not a valid value for ShareButton");
  if (!o) throw new Error("the ShareButton's 'url' prop can't be undefined");
  if (e === "Pinterest" && !s) throw new Error("the ShareButton's 'media' prop for the 'Pinterest' network can't be undefined");
  return i[a](r);
}
export {
  c as getSocialNetworkLink
};
